export default __webpack_public_path__ + "static/media/indigoLogo.e54ceb51.jpeg";